import { useEffect, useState } from "preact/hooks";
import fetchGroup from "./fetchGroup";
import { hydrateGroupProducts, mergeGroupProducts } from "../unwrapProducts";

/**
 *
 * @param {tag|gid} group Group tag (`group:xyz`), or product id `gid://shopify/Product/12345`
 * @param {string[]} familyIds Purple Dot product family GIDs to merge in alongside `group`
 * @param {string} productId The current product's GID, always fetched/included first
 * @param {Object[]} seedProducts Pre-rendered product family data to show before the storefront fetch resolves
 * @returns [groupData]
 */
export default function useProductGroup(
  group,
  familyIds = [],
  productId,
  seedProducts = []
) {
  const seeded = hydrateGroupProducts(seedProducts);
  const [groupData, setGroupData] = useState(seeded);
  const familyKey = (familyIds || []).filter(Boolean).join(",");

  useEffect(() => {
    const ids = familyKey ? familyKey.split(",") : [];
    const keys = [...ids];

    if (
      productId &&
      /^gid:\/\/shopify\/Product/.test(productId) &&
      !keys.includes(productId)
    ) {
      keys.unshift(productId);
    }

    if (group && !keys.includes(group)) keys.push(group);

    if (!keys.length) {
      setGroupData(seeded);
      return;
    }

    Promise.all(keys.map((key) => fetchGroup(key))).then((groups) => {
      setGroupData(mergeGroupProducts(seeded, groups.flat()));
    });
  }, [group, familyKey, productId]);

  return [groupData];
}
